
export const da={
    "statusCode": 0,
    "data": {
        "cacheExpiryTime": 320,
        "pages": 1,
        "pageIndex": 0,
        "scrubber": 0,
        "filters": [
            {
                "type": "FilterWidget",
                "title": "Cuisines",
                "key": "CUISINES",
                "configType": "checkbox",
                "visible": 1,
                "options": [
                    {
                        "option": "Afghani",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "American",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Arabian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Asian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Awadhi",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Bakery",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Barbecue",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Bengali",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Beverages",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Biryani",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "British",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Burgers",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Burmese",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Cafe",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Chaat",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Chinese",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Combo",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Continental",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Desserts",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "European",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Fast Food",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Grill",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "H",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Healthy Food",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Home Food",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Hyderabadi",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Ice Cream",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Ice Cream Cakes",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Indian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Italian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Italian-American",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Jain",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Japanese",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Juices",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Kebabs",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Keto",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Lebanese",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Lucknowi",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Maharashtrian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Mexican",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Middle Eastern",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Mughlai",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Nepalese",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "North Eastern",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "North Indian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Pan-Asian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Pastas",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Persian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Pizzas",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Punjabi",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Salads",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Seafood",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Snacks",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "South Indian",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Street Food",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Sushi",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Sweets",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Tandoor",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Thai",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Thalis",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Tibetan",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Waffle",
                        "selected": 0,
                        "visible": 1
                    }
                ],
                "detail": "",
                "heading": "Cuisines",
                "applicable": 1,
                "searchable": 1
            },
            {
                "type": "FilterWidget",
                "title": "Show Restaurants With",
                "key": "SHOW_RESTAURANTS_WITH",
                "configType": "checkbox",
                "visible": 1,
                "options": [
                    {
                        "option": "Offers",
                        "selected": 0,
                        "visible": 1
                    },
                    {
                        "option": "Pure Veg",
                        "selected": 0,
                        "visible": 1
                    }
                ],
                "detail": "",
                "heading": "Offers & More",
                "applicable": 1,
                "searchable": 0
            }
        ],
        "sorts": [
            {
                "type": "SortWidget",
                "key": "RELEVANCE",
                "title": "Relevance",
                "selected": 1,
                "visible": 1,
                "defaultSelection": true
            },
            {
                "type": "SortWidget",
                "key": "DELIVERY_TIME",
                "title": "Delivery Time",
                "selected": 0,
                "visible": 1,
                "defaultSelection": false
            },
            {
                "type": "SortWidget",
                "key": "RATING",
                "title": "Rating",
                "selected": 0,
                "visible": 1,
                "defaultSelection": false
            },
            {
                "type": "SortWidget",
                "key": "COST_FOR_TWO",
                "title": "Cost: Low to High",
                "selected": 0,
                "visible": 1,
                "defaultSelection": false
            },
            {
                "type": "SortWidget",
                "key": "COST_FOR_TWO_H2L",
                "title": "Cost: High to Low",
                "selected": 0,
                "visible": 1,
                "defaultSelection": false
            }
        ],
        "configs": {
            "ribbons": {
                "PREORDER": {
                    "type": "PREORDER",
                    "text": "Preorder",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#d53d4c",
                    "bottomBackgroundColor": "#af2330",
                    "priority": 3
                },
                "EXCLUSIVE": {
                    "type": "EXCLUSIVE",
                    "text": "Exclusive",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#fa4a5b",
                    "bottomBackgroundColor": "#d12a3b",
                    "priority": 2
                },
                "NEW": {
                    "type": "NEW",
                    "text": "Newly Added",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#d53d4c",
                    "bottomBackgroundColor": "#af2330",
                    "priority": 4
                },
                "REPEAT": {
                    "type": "REPEAT",
                    "text": "Repeat",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#D53D4C",
                    "bottomBackgroundColor": "#B02331",
                    "priority": 6
                },
                "CLOUD": {
                    "type": "CLOUD",
                    "text": "Daily Menus",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#fa4a5b",
                    "bottomBackgroundColor": "#d12a3b",
                    "priority": 5
                },
                "PREMIUM": {
                    "type": "PREMIUM",
                    "text": "Premium",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#8a584b",
                    "bottomBackgroundColor": "#583229",
                    "priority": 7
                },
                "PROMOTED": {
                    "type": "PROMOTED",
                    "text": "Promoted",
                    "textColor": "#ffffff",
                    "imageId": "sfefefefeegeg",
                    "topBackgroundColor": "#3a3c41",
                    "bottomBackgroundColor": "#1e2023",
                    "priority": 1
                }
            },
            "croutons": {
                "RAIN": {
                    "type": "Crouton",
                    "bgColor": "#282C3F",
                    "icon": "surge_listing_piuzrv",
                    "textColor": "#ffffff",
                    "title": "Bad Weather",
                    "message": "${amount} extra levied on some restaurants"
                },
                "SERVICEABLE_WITH_BANNER_RAIN": {
                    "type": "Crouton",
                    "bgColor": "#282C3F",
                    "icon": "rain_crouton_4x",
                    "textColor": "#ffffff",
                    "title": "Bad Weather",
                    "message": "Few restaurants unserviceable due to rains"
                }
            }
        },
        "cards": [
            {
                "cardType": "carousel",
                "layoutAlignmentType": "VERTICAL",
                "data": {
                    "type": "carousel",
                    "subtype": "topCarousel",
                    "data": {
                        "cards": [
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 635529,
                                    "creativeId": "rng/md/carousel/production/pneknawbadtvceqzwiep",
                                    "type": "restaurantCollectionV2",
                                    "link": "49301",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "thirdPartyVendor": "",
                                    "thirdPartyAddress": false
                                }
                            },
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 304829,
                                    "creativeId": "rng/md/carousel/production/jcjcvebiczqe5jr2vijo",
                                    "type": "restaurantCollectionV2",
                                    "link": "47667",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "thirdPartyVendor": "",
                                    "thirdPartyAddress": false
                                }
                            },
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 619141,
                                    "creativeId": "rng/md/carousel/production/zpkkdkmvlj5cuvqbc50t",
                                    "type": "restaurantCollectionV2",
                                    "link": "56413",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "thirdPartyVendor": "",
                                    "thirdPartyAddress": false
                                }
                            },
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 607195,
                                    "creativeId": "rng/md/carousel/production/ifi2lbzxeu1hvsqrsip3",
                                    "type": "restaurantCollectionV2",
                                    "link": "56421",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "thirdPartyVendor": "",
                                    "thirdPartyAddress": false
                                }
                            }
                        ]
                    }
                },
                "parentWidget": false
            },
            {
                "cardType": "carousel",
                "layoutAlignmentType": "VERTICAL",
                "data": {
                    "type": "carousel",
                    "subtype": "openFilter",
                    "data": {
                        "cards": [
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 181684,
                                    "creativeId": "bkhjfipzydkoqncrxpyi",
                                    "type": "restaurantCollectionV2",
                                    "link": "11718",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "title": "Offers Near You",
                                    "subtitle": "0 OPTIONS",
                                    "restaurants": [],
                                    "totalCount": 0,
                                    "dwebOpenFilterTitle": "Offers Near You",
                                    "dwebOpenFilterBgColor": "#FF0000",
                                    "dwebOpenFilterSelectIcon": "eyperwsfhaoa5vktjtu4",
                                    "dwebOpenFilterDeselectIcon": "urw8usdf4mk9aywd59gq"
                                }
                            },
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 273242,
                                    "creativeId": "rng/md/carousel/production/vquntqrzvkb08pe59cec",
                                    "type": "restaurantCollectionV2",
                                    "link": "46147",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "title": "Top Picks",
                                    "subtitle": "0 OPTIONS",
                                    "restaurants": [],
                                    "totalCount": 0,
                                    "dwebOpenFilterTitle": "Top Picks",
                                    "dwebOpenFilterBgColor": "#FF0000",
                                    "dwebOpenFilterSelectIcon": "rng/md/carousel/production/vt13uzhjrg5r49kh9oru",
                                    "dwebOpenFilterDeselectIcon": "rng/md/carousel/production/ser2sttildk9yt7t2s91"
                                }
                            },
                            {
                                "type": "carouselElement",
                                "subtype": "image",
                                "data": {
                                    "bannerId": 181680,
                                    "creativeId": "a3jqjjod5taken7dh1bs",
                                    "type": "restaurantCollectionV2",
                                    "link": "11721",
                                    "cityId": 0,
                                    "restaurantUuid": "",
                                    "restaurantParentId": "0",
                                    "title": "Veg Only",
                                    "subtitle": "0 OPTIONS",
                                    "restaurants": [],
                                    "totalCount": 0,
                                    "dwebOpenFilterTitle": "Vegetarian Options",
                                    "dwebOpenFilterBgColor": "#FF0000",
                                    "dwebOpenFilterSelectIcon": "qtjc8dzfexg72lug37a0",
                                    "dwebOpenFilterDeselectIcon": "bm8bziikwyvwqsml1clm"
                                }
                            }
                        ]
                    }
                },
                "parentWidget": false
            },
            {
                "cardType": "seeAllRestaurants",
                "layoutAlignmentType": "VERTICAL",
                "data": {
                    "type": "seeAllRestaurants",
                    "data": {
                        "title": "SEE ALL",
                        "totalOpenRestaurants": 780,
                        "cards": [
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "610732",
                                    "name": "KFC",
                                    "uuid": "b1ba9a5e-2601-4cff-8e07-3fea35cb8d7d",
                                    "city": "4",
                                    "area": "Dwarka More",
                                    "totalRatingsString": "500+ ratings",
                                    "cloudinaryImageId": "56c9ab92bd79745fd152a30fa2525426",
                                    "cuisines": [
                                        "Burgers",
                                        "Biryani",
                                        "American",
                                        "Snacks",
                                        "Fast Food"
                                    ],
                                    "tags": [],
                                    "costForTwo": 40000,
                                    "costForTwoString": "₹400 FOR TWO",
                                    "deliveryTime": 25,
                                    "minDeliveryTime": 25,
                                    "maxDeliveryTime": 25,
                                    "slaString": "25 MINS",
                                    "lastMileTravel": 1.100000023841858,
                                    "slugs": {
                                        "restaurant": "kfc-dwarka-mor-uttam-nagar",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "KFC Restaurant B-2,Rama Part near dwarka more metro station. New Delhi 110059.",
                                    "locality": "Metro Station",
                                    "parentId": 547,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "40% off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "40% off | Use SWIGGYIT",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "40% OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use SWIGGYIT",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "ribbon": [
                                        {
                                            "type": "PROMOTED"
                                        }
                                    ],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "cid=6536729~p=1~eid=00000187-c40c-d21c-0a4b-b18c000c013c",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "1.1 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "610732",
                                        "deliveryTime": 25,
                                        "minDeliveryTime": 25,
                                        "maxDeliveryTime": 25,
                                        "lastMileTravel": 1.100000023841858,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": true,
                                    "avgRating": "4.0",
                                    "totalRatings": 500,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "399890",
                                    "name": "Pizza Wings",
                                    "uuid": "32ca4ccd-456c-474d-9818-ab5c4b21a02b",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "1000+ ratings",
                                    "cloudinaryImageId": "a46a6aa00709f771fabb45c864a81b5e",
                                    "cuisines": [
                                        "Pizzas",
                                        "Italian",
                                        "Mexican",
                                        "American"
                                    ],
                                    "tags": [],
                                    "costForTwo": 30000,
                                    "costForTwoString": "₹300 FOR TWO",
                                    "deliveryTime": 22,
                                    "minDeliveryTime": 22,
                                    "maxDeliveryTime": 22,
                                    "slaString": "22 MINS",
                                    "lastMileTravel": 1.2999999523162842,
                                    "slugs": {
                                        "restaurant": "pizza-wings-uttam-nagar-uttam-nagar",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "GROUND FLOOR WITHOUT ROOF RIGHTS OF PROP NO.-C1, 1A RAMA PARK UTTAM NAGAR-110059, DWARKA, South West   , Delhi-110059",
                                    "locality": "Rama Park",
                                    "parentId": 159048,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "FLAT150 off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "₹150 OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "1.2 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "399890",
                                        "deliveryTime": 22,
                                        "minDeliveryTime": 22,
                                        "maxDeliveryTime": 22,
                                        "lastMileTravel": 1.2999999523162842,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "4.0",
                                    "totalRatings": 1000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "390401",
                                    "name": "MOMOS MUNCHIES",
                                    "uuid": "8fbd3b8a-e0c3-4eb8-91ac-47dda07cf301",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "500+ ratings",
                                    "cloudinaryImageId": "b2vtbksqcabjg5xnhvz5",
                                    "cuisines": [
                                        "Chinese",
                                        "Tandoor",
                                        "Snacks",
                                        "Combo"
                                    ],
                                    "tags": [],
                                    "costForTwo": 25000,
                                    "costForTwoString": "₹250 FOR TWO",
                                    "deliveryTime": 31,
                                    "minDeliveryTime": 31,
                                    "maxDeliveryTime": 31,
                                    "slaString": "31 MINS",
                                    "lastMileTravel": 2.299999952316284,
                                    "slugs": {
                                        "restaurant": "momos-munchies-rani-bagh-rani-bagh",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "S-10 Param Puri, Uttam Nagar, New Delhi, Binda Pur, Dawarka, South West, Delhi 110059",
                                    "locality": "Param Puri",
                                    "parentId": 250874,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "10% off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "10% off | Use TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "10% off up to ₹40 | Use code TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "10% OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "10% off up to ₹40 | Use code TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "2.2 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "390401",
                                        "deliveryTime": 31,
                                        "minDeliveryTime": 31,
                                        "maxDeliveryTime": 31,
                                        "lastMileTravel": 2.299999952316284,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "3.8",
                                    "totalRatings": 500,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "4412",
                                    "name": "Da' Pizza Planet",
                                    "uuid": "61816a67-b215-4a01-9a73-c49c8b43cee9",
                                    "city": "4",
                                    "area": "Janakpuri",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "epsuanhdg24uw4fq6tea",
                                    "cuisines": [
                                        "Italian",
                                        "Pizzas"
                                    ],
                                    "tags": [],
                                    "costForTwo": 50000,
                                    "costForTwoString": "₹500 FOR TWO",
                                    "deliveryTime": 31,
                                    "minDeliveryTime": 31,
                                    "maxDeliveryTime": 31,
                                    "slaString": "31 MINS",
                                    "lastMileTravel": 5,
                                    "slugs": {
                                        "restaurant": "da-pizza-planet-south-delhi",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "# C2B/88A, Lal Sai Mandir Marg, Janakpuri, Opp. District Park, New Delhi, Delhi 110058",
                                    "locality": "Lal Sai Mandir Marg",
                                    "parentId": 300,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "50% off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "50% off on all orders",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "50% off on all orders",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "50% OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "50% off on all orders",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "ribbon": [
                                        {
                                            "type": "PROMOTED"
                                        }
                                    ],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 6400,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 6400,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "6400",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "cid=6565252~p=4~eid=00000187-c40c-d21c-0a4b-b18d000c046f",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "5 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "4412",
                                        "deliveryTime": 31,
                                        "minDeliveryTime": 31,
                                        "maxDeliveryTime": 31,
                                        "lastMileTravel": 5,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": true,
                                    "avgRating": "3.9",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "64035",
                                    "name": "The Burger Club",
                                    "uuid": "ca73967e-7251-4594-8de6-3c903d77b12d",
                                    "city": "4",
                                    "area": "Dwarka",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "jtloihnjdnzuvdg1y8qo",
                                    "cuisines": [
                                        "Fast Food",
                                        "American",
                                        "Beverages",
                                        "Desserts"
                                    ],
                                    "tags": [],
                                    "costForTwo": 25000,
                                    "costForTwoString": "₹250 FOR TWO",
                                    "deliveryTime": 21,
                                    "minDeliveryTime": 21,
                                    "maxDeliveryTime": 21,
                                    "slaString": "21 MINS",
                                    "lastMileTravel": 1.899999976158142,
                                    "slugs": {
                                        "restaurant": "the-burger-club-sector-3-dwarka",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "The burger club private limited dwarka mor . piller no 794,Near by Bank of brodra",
                                    "locality": "Sector 15",
                                    "parentId": 2285,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "Flat ₹125 off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "₹125 OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "1.8 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "64035",
                                        "deliveryTime": 21,
                                        "minDeliveryTime": 21,
                                        "maxDeliveryTime": 21,
                                        "lastMileTravel": 1.899999976158142,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "4.2",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "183329",
                                    "name": "Burger King",
                                    "uuid": "bac08ad8-cadf-484b-979f-ce8e2df86361",
                                    "city": "4",
                                    "area": "Dwarka",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "28fb13049b4e55297bb3f703cde63c35",
                                    "cuisines": [
                                        "Burgers",
                                        "American"
                                    ],
                                    "tags": [],
                                    "costForTwo": 35000,
                                    "costForTwoString": "₹350 FOR TWO",
                                    "deliveryTime": 24,
                                    "minDeliveryTime": 24,
                                    "maxDeliveryTime": 24,
                                    "slaString": "24 MINS",
                                    "lastMileTravel": 2.9000000953674316,
                                    "slugs": {
                                        "restaurant": "burger-king-dwarka-mod-new-delhi-uttam-nagar",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "C-1/4-5, Ground and Basement floor, Rama Park, Najafgarh Road,Uttam Nagar, New delhi 110059",
                                    "locality": "Rama Park",
                                    "parentId": 166,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "Get every item under 129",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Get every item under 129",
                                                "discountType": "FinalPrice",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Get every item under 129",
                                                "discountType": "FinalPrice",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "",
                                                "discountType": "FinalPrice",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Get every item under 129",
                                                "discountType": "FinalPrice",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "2.9 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "183329",
                                        "deliveryTime": 24,
                                        "minDeliveryTime": 24,
                                        "maxDeliveryTime": 24,
                                        "lastMileTravel": 2.9000000953674316,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "4.2",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "417201",
                                    "name": "Rominus Pizza & Burger",
                                    "uuid": "1e455d4d-3da8-4fb8-b78c-6b84fb9e14bf",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "1000+ ratings",
                                    "cloudinaryImageId": "9ec9ffd900c24ef751e2f34ba3d2fd4b",
                                    "cuisines": [
                                        "Pizzas",
                                        "Italian",
                                        "American",
                                        "Snacks",
                                        "Desserts",
                                        "Beverages",
                                        "Continental"
                                    ],
                                    "tags": [],
                                    "costForTwo": 15000,
                                    "costForTwoString": "₹150 FOR TWO",
                                    "deliveryTime": 22,
                                    "minDeliveryTime": 22,
                                    "maxDeliveryTime": 22,
                                    "slaString": "22 MINS",
                                    "lastMileTravel": 1.600000023841858,
                                    "slugs": {
                                        "restaurant": "rominus-pizza-and-burger-laxmi-nagar-laxmi-nagar-2",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "C-8 Rama Park, Metro Pillar No 769, Near Dwarka Metro Station",
                                    "locality": "Laxmi Nagar",
                                    "parentId": 8387,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "FLAT150 off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "₹150 OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "1.6 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "417201",
                                        "deliveryTime": 22,
                                        "minDeliveryTime": 22,
                                        "maxDeliveryTime": 22,
                                        "lastMileTravel": 1.600000023841858,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "3.9",
                                    "totalRatings": 1000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "101565",
                                    "name": "Bakingo",
                                    "uuid": "d6df8060-2fa3-4a3a-b513-33066ebfc5e2",
                                    "city": "4",
                                    "area": "Dwarka",
                                    "totalRatingsString": "5000+ ratings",
                                    "cloudinaryImageId": "ouwahmzefqldk8jnecyq",
                                    "cuisines": [
                                        "Bakery",
                                        "Desserts",
                                        "Beverages",
                                        "Snacks"
                                    ],
                                    "tags": [],
                                    "costForTwo": 30000,
                                    "costForTwoString": "₹300 FOR TWO",
                                    "deliveryTime": 28,
                                    "minDeliveryTime": 28,
                                    "maxDeliveryTime": 28,
                                    "slaString": "28 MINS",
                                    "lastMileTravel": 4.199999809265137,
                                    "slugs": {
                                        "restaurant": "bakingo-dwarka-vam",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "C 76, 1ST FLOOR, MAHAVIR VIHAR, MAIN ROAD DWARKA, South West Delhi, Delhi, 110075",
                                    "locality": "Sector 2",
                                    "parentId": 3818,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "ribbon": [
                                        {
                                            "type": "PROMOTED"
                                        }
                                    ],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 5400,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 5400,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "5400",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "cid=6509470~p=10~eid=00000187-c40c-d21c-0a4b-b18f000c0a42",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "4.1 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "101565",
                                        "deliveryTime": 28,
                                        "minDeliveryTime": 28,
                                        "maxDeliveryTime": 28,
                                        "lastMileTravel": 4.199999809265137,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": true,
                                    "avgRating": "4.2",
                                    "totalRatings": 5000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "659414",
                                    "name": "La Pino'z Pizza",
                                    "uuid": "d9f99e2b-dd29-4424-944d-a37de4f56981",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "100+ ratings",
                                    "cloudinaryImageId": "c99aa4e68f6f6235e8aeb420932c13d7",
                                    "cuisines": [
                                        "Pizzas",
                                        "Italian",
                                        "Pastas",
                                        "Mexican",
                                        "Desserts"
                                    ],
                                    "tags": [],
                                    "costForTwo": 40000,
                                    "costForTwoString": "₹400 FOR TWO",
                                    "deliveryTime": 21,
                                    "minDeliveryTime": 21,
                                    "maxDeliveryTime": 21,
                                    "slaString": "21 MINS",
                                    "lastMileTravel": 1.600000023841858,
                                    "slugs": {
                                        "restaurant": "la-pinoz-pizza-panchkula-janakpuri",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "B-8 ground floor Rama park uttam nagar najafgarh road new delhi -110059",
                                    "locality": "DwarkaMor",
                                    "parentId": 4961,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "1.6 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "659414",
                                        "deliveryTime": 21,
                                        "minDeliveryTime": 21,
                                        "maxDeliveryTime": 21,
                                        "lastMileTravel": 1.600000023841858,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "3.5",
                                    "totalRatings": 100,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "647665",
                                    "name": "Momos Junction",
                                    "uuid": "602cb3e9-8663-4e09-9724-325a90401c2d",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "50+ ratings",
                                    "cloudinaryImageId": "5cc468c26f9fdab2c6c9f3f4b3e6e613",
                                    "cuisines": [
                                        "North Indian",
                                        "Pastas",
                                        "Fast Food"
                                    ],
                                    "tags": [],
                                    "costForTwo": 10000,
                                    "costForTwoString": "₹100 FOR TWO",
                                    "deliveryTime": 32,
                                    "minDeliveryTime": 32,
                                    "maxDeliveryTime": 32,
                                    "slaString": "32 MINS",
                                    "lastMileTravel": 2.200000047683716,
                                    "slugs": {
                                        "restaurant": "momos-junction-rani-bagh-rani-bagh-2",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "WZ-34, Bal Udhyan Rd, Block C, Uttam Nagar, Delhi, 110059, India",
                                    "locality": "Bal Udhyan Road",
                                    "parentId": 12330,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "2.2 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "647665",
                                        "deliveryTime": 32,
                                        "minDeliveryTime": 32,
                                        "maxDeliveryTime": 32,
                                        "lastMileTravel": 2.200000047683716,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "3.6",
                                    "totalRatings": 50,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "364251",
                                    "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
                                    "uuid": "525a4f30-5bc5-4d74-8757-c2d77b0a867e",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "1000+ ratings",
                                    "cloudinaryImageId": "asuqyfaylulv6iv4ejgf",
                                    "cuisines": [
                                        "Desserts",
                                        "Ice Cream",
                                        "Ice Cream Cakes"
                                    ],
                                    "tags": [],
                                    "costForTwo": 30000,
                                    "costForTwoString": "₹300 FOR TWO",
                                    "deliveryTime": 30,
                                    "minDeliveryTime": 30,
                                    "maxDeliveryTime": 30,
                                    "slaString": "30 MINS",
                                    "lastMileTravel": 2.799999952316284,
                                    "slugs": {
                                        "restaurant": "kwality-walls-frozen-dessert-and-ice-cream-shop-uttam-nagar-uttam-nagar-4",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "Q-23, BHAGAT ENCLAVE, UTTAM NAGAR, NEW DELHI-110059\t",
                                    "locality": "Bhagat Enclave",
                                    "parentId": 582,
                                    "unserviceable": false,
                                    "veg": true,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "ribbon": [
                                        {
                                            "type": "PROMOTED"
                                        }
                                    ],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "cid=6552355~p=13~eid=00000187-c40c-d21c-0a4b-b190000c0d45",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "2.7 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "364251",
                                        "deliveryTime": 30,
                                        "minDeliveryTime": 30,
                                        "maxDeliveryTime": 30,
                                        "lastMileTravel": 2.799999952316284,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": true,
                                    "avgRating": "4.2",
                                    "totalRatings": 1000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "254009",
                                    "name": "McDonald's",
                                    "uuid": "68c56c67-6889-4b35-b606-894c59900d3f",
                                    "city": "4",
                                    "area": "Dwarka",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "1293a58ab5610f4c730c3d8cb6ac1b65",
                                    "cuisines": [
                                        "American"
                                    ],
                                    "tags": [],
                                    "costForTwo": 40000,
                                    "costForTwoString": "₹400 FOR TWO",
                                    "deliveryTime": 22,
                                    "minDeliveryTime": 22,
                                    "maxDeliveryTime": 22,
                                    "slaString": "22 MINS",
                                    "lastMileTravel": 3,
                                    "slugs": {
                                        "restaurant": "mcdonalds-delhi-dwarka-dwarka",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "Delhi Dwarka, Plot no, 15, Ground Floor, Shop no, 3, Sector, 5, Raj Laxmi Plaza (MLU), Dwarka, New Delhi- 110075",
                                    "locality": "Sector 5",
                                    "parentId": 630,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 4600,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 4600,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "4600",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "3 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "254009",
                                        "deliveryTime": 22,
                                        "minDeliveryTime": 22,
                                        "maxDeliveryTime": 22,
                                        "lastMileTravel": 3,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "4.3",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "222233",
                                    "name": "late night delivery",
                                    "uuid": "b983ab9b-4ef6-439e-acdb-93f4bdc9bb0a",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "50+ ratings",
                                    "cloudinaryImageId": "scbevejfocn0zxx2vkm4",
                                    "cuisines": [
                                        "Indian"
                                    ],
                                    "tags": [],
                                    "costForTwo": 25000,
                                    "costForTwoString": "₹250 FOR TWO",
                                    "deliveryTime": 25,
                                    "minDeliveryTime": 25,
                                    "maxDeliveryTime": 25,
                                    "slaString": "25 MINS",
                                    "lastMileTravel": 0.800000011920929,
                                    "slugs": {
                                        "restaurant": "late-night-delivery-uttam-nagar-uttam-nagar",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "51-B, Sainik Nagar,nawada, uttam nagar, BINDA PUR, DWARKA, South West, Delhi-110059",
                                    "locality": "Sainik Nagar road",
                                    "parentId": 123704,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "10% off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "10% off | Use TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "10% off | Use code TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "10% OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "10% off | Use code TRYNEW",
                                                "discountType": "Percentage",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "0.8 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "222233",
                                        "deliveryTime": 25,
                                        "minDeliveryTime": 25,
                                        "maxDeliveryTime": 25,
                                        "lastMileTravel": 0.800000011920929,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "3.7",
                                    "totalRatings": 50,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "14711",
                                    "name": "Burger Singh (Big Punjabi Burgers)",
                                    "uuid": "8ff6484b-8e0a-4573-aa1b-a273a7fdeeb6",
                                    "city": "4",
                                    "area": "Dwarka",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "fjxgi14arldyh2fwzgaw",
                                    "cuisines": [
                                        "Snacks",
                                        "Fast Food",
                                        "Indian",
                                        "American",
                                        "Beverages",
                                        "Desserts",
                                        "Mughlai",
                                        "North Indian",
                                        "Biryani",
                                        "Tibetan",
                                        "Chinese",
                                        "Continental"
                                    ],
                                    "tags": [],
                                    "costForTwo": 30000,
                                    "costForTwoString": "₹300 FOR TWO",
                                    "deliveryTime": 19,
                                    "minDeliveryTime": 19,
                                    "maxDeliveryTime": 19,
                                    "slaString": "19 MINS",
                                    "lastMileTravel": 2.9000000953674316,
                                    "slugs": {
                                        "restaurant": "burger-singh-local-shopping-centre-dwarka",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "Shop No-F7 First Floor, plot number 3, LSC market Near HDFC bank Sector 4",
                                    "locality": "Sector 4",
                                    "parentId": 375065,
                                    "unserviceable": false,
                                    "veg": false,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "Flat ₹125 off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "₹125 OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "distance",
                                                "fee": 3800,
                                                "message": ""
                                            },
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 3800,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "3800",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": ""
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "2.9 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "14711",
                                        "deliveryTime": 19,
                                        "minDeliveryTime": 19,
                                        "maxDeliveryTime": 19,
                                        "lastMileTravel": 2.9000000953674316,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": false,
                                    "avgRating": "4.3",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            },
                            {
                                "type": "restaurant",
                                "data": {
                                    "type": "F",
                                    "id": "30577",
                                    "name": "Lala Da Shudh Vaishno Dhaba",
                                    "uuid": "238c6952-b110-4fdc-b430-4aecfe26ee8b",
                                    "city": "4",
                                    "area": "Uttam Nagar",
                                    "totalRatingsString": "10000+ ratings",
                                    "cloudinaryImageId": "ze7vm8lstqwg6azkizis",
                                    "cuisines": [
                                        "North Indian",
                                        "Snacks",
                                        "Sweets"
                                    ],
                                    "tags": [],
                                    "costForTwo": 20000,
                                    "costForTwoString": "₹200 FOR TWO",
                                    "deliveryTime": 21,
                                    "minDeliveryTime": 21,
                                    "maxDeliveryTime": 21,
                                    "slaString": "21 MINS",
                                    "lastMileTravel": 3,
                                    "slugs": {
                                        "restaurant": "lala-da-shudh-vaishno-dhaba-uttam-nagar-uttam-nagar",
                                        "city": "delhi"
                                    },
                                    "cityState": "4",
                                    "address": "Main Najafgarh Road, Opposite Metro Pillar No. 676, Uttam Nagar, New Delhi",
                                    "locality": "Main Najafgarh Road",
                                    "parentId": 4499,
                                    "unserviceable": false,
                                    "veg": true,
                                    "select": false,
                                    "favorite": false,
                                    "tradeCampaignHeaders": [],
                                    "aggregatedDiscountInfo": {
                                        "header": "FLAT150 off",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "aggregatedDiscountInfoV2": {
                                        "header": "₹150 OFF",
                                        "shortDescriptionList": [
                                            {
                                                "meta": "Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "descriptionList": [
                                            {
                                                "meta": "FLAT150 off | Use FLATDEAL",
                                                "discountType": "Flat",
                                                "operationType": "RESTAURANT"
                                            }
                                        ],
                                        "subHeader": "",
                                        "headerType": 0,
                                        "superFreedel": ""
                                    },
                                    "ribbon": [
                                        {
                                            "type": "PROMOTED"
                                        }
                                    ],
                                    "chain": [],
                                    "feeDetails": {
                                        "fees": [
                                            {
                                                "name": "time",
                                                "fee": 0,
                                                "message": ""
                                            },
                                            {
                                                "name": "distance",
                                                "fee": 4600,
                                                "message": ""
                                            },
                                            {
                                                "name": "special",
                                                "fee": 0,
                                                "message": ""
                                            }
                                        ],
                                        "totalFees": 4600,
                                        "message": "",
                                        "title": "Delivery Charge",
                                        "amount": "4600",
                                        "icon": ""
                                    },
                                    "availability": {
                                        "opened": true,
                                        "nextOpenMessage": "",
                                        "nextCloseMessage": "Closes soon"
                                    },
                                    "longDistanceEnabled": 0,
                                    "rainMode": "NONE",
                                    "thirdPartyAddress": false,
                                    "thirdPartyVendor": "",
                                    "adTrackingID": "cid=6376176~p=19~eid=00000187-c40c-d21c-0a4b-b192000c1312",
                                    "badges": {
                                        "imageBased": [],
                                        "textBased": [],
                                        "textExtendedBadges": []
                                    },
                                    "lastMileTravelString": "3 kms",
                                    "hasSurge": false,
                                    "sla": {
                                        "restaurantId": "30577",
                                        "deliveryTime": 21,
                                        "minDeliveryTime": 21,
                                        "maxDeliveryTime": 21,
                                        "lastMileTravel": 3,
                                        "lastMileDistance": 0,
                                        "serviceability": "SERVICEABLE",
                                        "rainMode": "NONE",
                                        "longDistance": "NOT_LONG_DISTANCE",
                                        "preferentialService": false,
                                        "iconType": "EMPTY"
                                    },
                                    "promoted": true,
                                    "avgRating": "3.9",
                                    "totalRatings": 10000,
                                    "new": false
                                },
                                "subtype": "basic"
                            }
                        ],
                        "totalRestaurants": 780
                    },
                    "subtype": "personalized"
                },
                "parentWidget": false
            }
        ],
        "nextPageFetch": 0
    },
    "tid": "1a9f84ee-ea1a-460a-b5e3-b04e2733dcc2",
    "sid": "6qodc881-9f84-4137-8871-c7b896ad54bc",
    "deviceId": "dbbfd23d-1b00-ed84-134d-ab77d6ad5471",
    "csrfToken": "mXx63nkFcMsF-2c9gqzpbnxRSGdWl7KeDe9su7WU"
};